import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
export function logFeedDisplayed() {
  if (!e.rr()) return;
  const i = e.ar();
  return i ? i.qr(r.Cr.Br).O : void 0;
}
